import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { InlineAuthForms, InlineAuthFormsProps } from './InlineAuthForms';
import { ReceiptForm } from '../ReceiptForm';

interface EmailAuthFlowProps {
    title: string;
    footer: string;
    defaultEmail: string;
    isLoading: boolean;
    isAuthStageActive: boolean;
    subtitle: string | undefined;
    onSubmit: (values: { email: string }) => void | Promise<void>;
    authFormsProps: InlineAuthFormsProps;
}

export const EmailAuthFlow: React.FC<EmailAuthFlowProps> = ({
    title,
    footer,
    defaultEmail,
    isLoading,
    isAuthStageActive,
    subtitle,
    onSubmit,
    authFormsProps
}) => {
    const theme = useTheme();

    return (
        <Box px={2} py={2}>
            <Typography
                align="center"
                variant="h6"
                sx={{ fontWeight: theme.typography.fontWeightBold, color: 'text.primary', pb: 1 }}
            >
                {title}
            </Typography>
            {subtitle && (
                <Typography align="center" variant="body2" sx={{ color: 'text.secondary', pb: 1 }}>
                    {subtitle}
                </Typography>
            )}
            {isAuthStageActive && <InlineAuthForms {...authFormsProps} />}
            {!isAuthStageActive && (
                <>
                    <ReceiptForm defaultEmail={defaultEmail} onSubmit={onSubmit} isLoading={isLoading} />
                    <Typography align="center" variant="caption" sx={{ display: 'block', mt: 1 }}>
                        {footer}
                    </Typography>
                </>
            )}
        </Box>
    );
};
